export default __webpack_public_path__ + "static/media/detail_mobile_10_2.70fa93e7.jpg";